export enum AuthErrorReason {
  Unhandled = 'UNHANDLED',
  AuthenticationFailed = 'AUTHENTICATION_FAILED',
  AuthorizationFailed = 'AUTHORIZATION_FAILED',
  TenantNotAllowed = 'TENANT_NOT_ALLOWED',
  UserNotAllowed = 'USER_NOT_ALLOWED',
}

export interface IAuthError {
  reason: AuthErrorReason;
  message: string;
}

export enum AuthStatus {
  idle = 'IDLE',
  loading = 'LOADING',
  authenticated = 'AUTHENTICATED',
  authorized = 'AUTHORIZED',
  error = 'ERROR',
}

export interface IAuthState {
  ssoToken: string;
  roles: string[];
  error?: IAuthError;
  status: AuthStatus;
  b2cStatus: AuthStatus;
}

export const AUTH_INITIAL_STATE: IAuthState = {
  ssoToken: '',
  roles: [],
  status: AuthStatus.idle,
  b2cStatus: AuthStatus.idle,
};

// TODO: Get employee email with Graph API
export interface IGraphAPIConfigState {
  access_token: string;
}

export const GRAPH_API_TOKEN_INITIAL_STATE: IGraphAPIConfigState = {
  access_token: '',
};
